// Overlay permanent (caméra zoom 1) : la MÉTÉO RÉELLE de Grisolles, en haut à droite, sous l'horloge.
// Alimentée par le message `world-facts` du serveur (Open-Meteo, 0 token côté jeu). Affiche aussi une
// puce "Vacances scolaires" quand le vrai calendrier (Zone C) est en vacances. Masquée tant qu'aucune
// donnée n'est arrivée (mode mock / hors-ligne → reste cachée, sans erreur).
import 'phaser'
import { SceneName } from './enums/SceneNames'
import GlobalInfo from '../GlobalInfo'
import ServerLink from '../net/ServerLink'
import type { WorldFacts } from '../net/protocol'

const MARGIN = 10, TOP = 100   // sous l'horloge + les boutons Journal & 🚪 Chambres du HUD (qui finissent ~y96)

export default class WeatherScene extends Phaser.Scene {
    private weather!: Phaser.GameObjects.Text
    private holiday!: Phaser.GameObjects.Text

    constructor() { super(SceneName.Weather) }

    create(): void {
        this.weather = this.add.text(this.scale.width - MARGIN, TOP, '', {
            fontFamily: 'sans-serif', fontSize: '13px', fontStyle: 'bold', color: '#f7fafc',
            backgroundColor: '#10151fcc', padding: { x: 8, y: 4 },
        }).setOrigin(1, 0).setScrollFactor(0).setResolution(3).setDepth(2000).setVisible(false)

        this.holiday = this.add.text(this.scale.width - MARGIN, TOP + 26, '🏖️ Vacances scolaires', {
            fontFamily: 'sans-serif', fontSize: '10px', fontStyle: 'bold', color: '#10151f',
            backgroundColor: '#f6e05ee8', padding: { x: 6, y: 3 },
        }).setOrigin(1, 0).setScrollFactor(0).setResolution(3).setDepth(2000).setVisible(false)

        GlobalInfo.on('server-world-facts', this.onFacts, this)
        this.scale.on('resize', this.layout, this)
        this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
            GlobalInfo.off('server-world-facts', this.onFacts, this)
            this.scale.off('resize', this.layout, this)
        })

        if (ServerLink.worldFacts) this.render(ServerLink.worldFacts)  // cached value on (re)create
    }

    private onFacts = (p: { facts: WorldFacts }): void => this.render(p.facts)

    private render(facts: WorldFacts): void {
        const w = facts.weather
        if (w) {
            this.weather.setText(`${weatherGlyph(w.code, w.hot)} ${w.tempC}°C · ${w.label}`).setVisible(true)
        }
        const onHoliday = facts.calendar?.onHoliday ?? false
        this.holiday.setVisible(onHoliday)
        this.layout()
    }

    private layout = (): void => {
        const x = this.scale.width - MARGIN
        this.weather?.setX(x)
        this.holiday?.setX(x)
    }
}

/** WMO weather code → emoji glyph (hot overrides to 🥵). */
function weatherGlyph(code: number, hot: boolean): string {
    if (hot) return '🥵'
    if (code === 0 || code === 1) return '☀️'
    if (code === 2) return '⛅'
    if (code === 3) return '☁️'
    if (code === 45 || code === 48) return '🌫️'
    if (code >= 51 && code <= 57) return '🌦️'
    if (code >= 61 && code <= 67) return '🌧️'
    if ((code >= 71 && code <= 77) || code === 85 || code === 86) return '🌨️'
    if (code >= 80 && code <= 82) return '🌦️'
    if (code >= 95) return '⛈️'
    return '🌡️'
}
